export default {
      id: "vague_css-usage",
      viewBox: "0 0 2000 107",
      url: "../dist/images/" + "sprite.svg#vague_css-usage",
      toString: function () {
        return this.url;
      }
    }